import { HTTP as http } from '../../http'

const PREFIX = '/shipping'

export default {
    shippingCalculate: (data) => {
        return http.post(PREFIX+'/calculate', data)
    },

    setShippingMethod: (data) => {
        return http.post(PREFIX+'/setMethod', data)
    },

    destroySessionShippingMethod: () => {
        return http.post(PREFIX+'/destroySessionShippingMethod')
    },

    getShippingMethod: (data) => {
        return http.get(PREFIX+'/getMethod', data)
    },

    getCepDestination: () => {
        return http.get(PREFIX+'/getCepDestination')
    },
    
    getAllShippingCalculation: () => {
        return http.post(PREFIX+'/getAllShippingCalculation')
    },

    getShippingCalculateByProduct: (data, id) => {
        return http.post(PREFIX+'/getShippingCalculateByProduct/'+id, data)
    },

    getCities: (data, page = 1) => {
        return http.post('city/search/?page='+page, data)
    }

}